import _taggedTemplateLiteral from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mix-blend-mode: overlay;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  background: linear-gradient(\n    90deg,\n    rgba(156, 51, 176, 1) 0%,\n    rgba(99, 23, 120, 1) 100%\n  );\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from "react";
import { Flex, IconClubCatchTagBg, Box, themeGet, styled } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
var CCBgFlex = styled(Flex)(_templateObject(), themeGet("colors.clubCatch.primary"));
var BgIcon = styled(IconClubCatchTagBg)(_templateObject2());
export var ClubCatchHeader = function ClubCatchHeader(_ref) {
  var children = _ref.children;
  return ___EmotionJSX(CCBgFlex, {
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    p: "1em 1em 2.2em",
    color: "white",
    overflow: "hidden"
  }, children, ___EmotionJSX(Box, {
    position: "absolute",
    bottom: 0,
    right: "-25px"
  }, ___EmotionJSX(BgIcon, {
    name: "clubCatchTagBg",
    fill: "white",
    width: "148px",
    height: "189px",
    opacity: 0.15
  })));
};
export default ClubCatchHeader;